export default __webpack_public_path__ + "static/media/sc-mail-active-ico.8ef14c9f.svg";